import L from 'leaflet';
import { SvgIcon } from '../Extensions/SvgIcon';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import StyrOchStäll from '../PopupTemplates/StyrOchStäll';
import StyrOchStällBike from '../PopupTemplates/StyrOchStällBike';
import { StyrOchStällSource } from '../Sources/StyrOchStällSource';

export const rentalBike = function (options?: ClusteredMarkerLayerOptions): L.LayerGroup {
    const styrOchStällSource = new StyrOchStällSource({ updateInterval: 60 });

    const stationDefaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Lånecykelstation',
        itemPlural: 'lånecykelstationer',
        source: styrOchStällSource,
        customIcon: (feature) =>
            new SvgIcon({
                iconId: feature.properties.availableBikes ? 'bike-station' : 'empty-bike-station',
                iconSize: [24, 36],
                iconAnchor: [12, 36],
                popupAnchor: [0, -36],
            }),
        customClusterIconId: (markers) => {
            return markers.find((marker) => !!marker.feature.properties.availableBikes) ? 'bike-station-cluster' : 'empty-bike-station-cluster';
        },
        popupTemplate: StyrOchStäll,
        defaultFilter: {
            filterFn: function (features) {
                return features.filter((feature) => feature.properties.type === 'station');
            },
        },
    };

    const bikeDefaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Lånecykel',
        itemPlural: 'lånecyklar',
        source: styrOchStällSource,
        customIcon: new SvgIcon({
            iconId: 'nextbike-circle',
            iconSize: [20, 20],
            popupAnchor: [0, -10],
        }),
        popupTemplate: StyrOchStällBike,
        defaultFilter: {
            filterFn: function (features) {
                return features.filter((feature) => feature.properties.type === 'bike');
            },
        },
    };

    const stationLayer = new ClusteredMarkerLayer({ ...stationDefaultOptions, ...options });

    const bikeLayer = new ClusteredMarkerLayer({ ...bikeDefaultOptions, ...options });

    return L.layerGroup([bikeLayer, stationLayer]);
};
